"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getDefaultThemeName = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get("/themes.config.json", {
              validateStatus: function validateStatus(status) {
                return status === 404 || status >= 200 && status < 300;
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data.defaultThemeName);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.log("No default theme found. The CX theme will be used", _context.t0);

          case 10:
            return _context.abrupt("return", null);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function getDefaultThemeName() {
    return _ref.apply(this, arguments);
  };
}();

var _default = getDefaultThemeName;
exports.default = _default;